'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountDownTimer = function (_Component) {
  (0, _inherits3.default)(CountDownTimer, _Component);

  function CountDownTimer(props) {
    (0, _classCallCheck3.default)(this, CountDownTimer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CountDownTimer.__proto__ || (0, _getPrototypeOf2.default)(CountDownTimer)).call(this, props));

    _this.state = { currentCount: props.countTime };
    return _this;
  }

  (0, _createClass3.default)(CountDownTimer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.intervalId = setInterval(this.timer.bind(this), 1000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
    }
  }, {
    key: 'timer',
    value: function timer() {
      this.setState({
        currentCount: this.state.currentCount - 1
      });

      if (this.state.currentCount < 1) {
        clearInterval(this.intervalId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        this.state.currentCount
      );
    }
  }]);
  return CountDownTimer;
}(_react.Component);

CountDownTimer.defaultProps = {
  countTime: 0
};
CountDownTimer.propTypes = {
  countTime: _propTypes2.default.number
};
exports.default = CountDownTimer;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CountDownTimer/CountDownTimer.js
// module id = 568
// module chunks = 11